import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { ColumnsType } from 'antd/es/table/interface';
import dayjs from 'dayjs';

import LogSyncContext from '@totem/components/administration/logSync/LogSyncContext';
import { LogSyncListItem } from '@totem/components/administration/logSync/types';
import IBTable from '@totem/components/ui_components/antDesignOverrides/IBTable';
import InputContext from '@totem/components/ui_components/reportSettings/InputContext';

const LogSyncTable = () => {
  const { data, loading, totalRecords } = useContext(LogSyncContext);
  const { input, handleTableChange, getFilterOptions } =
    useContext(InputContext);

  const columns: ColumnsType<LogSyncListItem> = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: true,
      filters: getFilterOptions('name'),
      filterMultiple: true,
      filterSearch: true,
      render: (_, record) => (
        <Link to={`/dashboard/admin/logSync/${record.id}`}>{record.name}</Link>
      ),
    },
    {
      title: 'Connection',
      dataIndex: 'connection',
      key: 'connection',
      sorter: true,
      filters: getFilterOptions('connection'),
      filterMultiple: true,
      filterSearch: true,
      render: (connection?: string) => connection || '—',
    },
    {
      title: 'Site',
      dataIndex: 'site',
      key: 'site',
      sorter: true,
      filters: getFilterOptions('site'),
      filterMultiple: true,
      filterSearch: true,
      render: (site?: string) => site || '—',
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 200,
      sorter: true,
      render: (createdAt: string) =>
        createdAt ? dayjs(createdAt).format('YYYY-MM-DD HH:mm:ss') : '—',
    },
  ];

  return (
    <IBTable<LogSyncListItem>
      columns={columns}
      dataSource={data}
      loading={loading}
      rowKey="id"
      onChange={handleTableChange}
      pagination={{
        current: input.pagination.page,
        pageSize: input.pagination.pageSize,
        total: totalRecords,
        showSizeChanger: true,
      }}
    />
  );
};

export default LogSyncTable;
